import { render, staticRenderFns } from "./UserGeneral.vue?vue&type=template&id=ee2ab3b2&scoped=true"
import script from "./UserGeneral.vue?vue&type=script&lang=js"
export * from "./UserGeneral.vue?vue&type=script&lang=js"
import style0 from "./UserGeneral.vue?vue&type=style&index=0&id=ee2ab3b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee2ab3b2",
  null
  
)

export default component.exports